export function initializeVersionSelectionState(entity) {
    return {
        entity,
        leftVersion: null,
        rightVersion: null,
        leftVersionItems: [],
        rightVersionItems: [],
    };
}
export function reduceVersionSelectionState(state, action) {
    const newState = action.reduce(state);
    // if (state !== newState) console.log(`State changed for ${action.constructor.name}`, state, action, newState);
    return newState;
}
// ACTIONS
class UpdateVersionHistoryAction {
    value;
    constructor(value) {
        this.value = value;
    }
    reduce(state) {
        const versions = new Set();
        for (const edge of this.value.edges) {
            if (edge.node.isError())
                continue;
            const event = edge.node.value;
            const entityInfo = 'entities' in event ? event.entities.find((it) => it.id === state.entity.id) : null;
            if (!entityInfo)
                continue;
            versions.add(entityInfo.version);
        }
        const sortedVersions = Array.from(versions).sort((a, b) => b - a); // descending
        let { leftVersion, rightVersion } = state;
        if (leftVersion === null) {
            leftVersion = sortedVersions[0] ?? null;
        }
        if (rightVersion === null) {
            rightVersion = sortedVersions[1] ?? null;
        }
        const versionItems = this.createItems(sortedVersions);
        return {
            ...state,
            leftVersion,
            rightVersion,
            leftVersionItems: versionItems,
            rightVersionItems: versionItems,
        };
    }
    createItems(versions) {
        return versions.map((it) => ({
            version: it,
            enabled: true,
        }));
    }
}
class ChangeLeftVersionAction {
    version;
    constructor(version) {
        this.version = version;
    }
    reduce(state) {
        if (this.version === state.leftVersion)
            return state;
        return {
            ...state,
            leftVersion: this.version,
        };
    }
}
class ChangeRightVersionAction {
    version;
    constructor(version) {
        this.version = version;
    }
    reduce(state) {
        if (this.version === state.rightVersion)
            return state;
        return {
            ...state,
            rightVersion: this.version,
        };
    }
}
export const VersionSelectionAction = {
    UpdateVersionHistory: UpdateVersionHistoryAction,
    ChangeLeftVersion: ChangeLeftVersionAction,
    ChangeRightVersion: ChangeRightVersionAction,
};
//# sourceMappingURL=VersionSelectionReducer.js.map